import { render, staticRenderFns } from "./DeclinedStudentList.vue?vue&type=template&id=3f51fc59"
import script from "./DeclinedStudentList.vue?vue&type=script&lang=js"
export * from "./DeclinedStudentList.vue?vue&type=script&lang=js"
import style0 from "./DeclinedStudentList.vue?vue&type=style&index=0&id=3f51fc59&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports